import { Box, Menu, MenuItem, Select } from '@mui/material'

export const TNMSelectField = (props: any) => {
  const { options, label, value, onChange, name, error } = props
  return (
    <Select
      label={label}
      value={value} // Set value to empty string if it's falsy
      onChange={onChange}
      name={name}
      variant='filled'
      error={error}>
      {options.map((option: any) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name} {option.baseReportNumber}
        </MenuItem>
      ))}
    </Select>
  )
}
